import React, {  useEffect, useState } from 'react';
import Globals from '../../../Globals';
import { useCookies } from 'react-cookie';
import DealerService from 'services/DealerService';
import BackofficeService from 'services/BackofficeService';
import DatePicker from '../../bronson/Datepicker';
import Loading from '../../bronson/Loading';

import * as Yup from 'yup';

const DEFAULT_TIPO_INCIDENCIA_ID = '1'; // Sin Incidencia

const actaDevolucionSchema = Yup.object().shape({
    fechaDevolucion: Yup.mixed().required('Campo obligatorio'),
    kmDevolucion: Yup.number().typeError('Campo obligatorio').moreThan(0, 'Campo obligatorio'),
    concesionario: Yup.string().required('Campo obligatorio'),
    devolucionCodTipoVia: Yup.string().trim().required('Campo obligatorio'),
    devolucionNombreVia: Yup.string().trim().required('Campo obligatorio'),
    devolucionNumeroVia: Yup.string().trim().required('Campo obligatorio'),
    devolucionCodPostal: Yup.string().trim().required('Campo obligatorio'),
    devolucionCodPoblacion: Yup.string().required('Campo obligatorio'),
    devolucionCodPoblacion: Yup.string().required('Campo obligatorio'),
    personaRecogeVehiculo: Yup.string().trim().required('Campo obligatorio'),
    telContacto: Yup.string().trim().required('Campo obligatorio'),
    emailContacto: Yup.string().email('Correo inválido').required('Campo obligatorio'),
    perfilConcesionario: Yup.object({
        identificacionCliDevuelve: Yup.string().required('Campo obligatorio'),
        nombreCliDevuelve: Yup.string().required('Campo obligatorio'),
        primerApellidoCliDevuelve: Yup.string().required('Campo obligatorio'),
        segundoApellidoCliDevuelve:  Yup.string().required('Campo obligatorio'),
        emailCliDevuelve: Yup.string().email('Correo inválido').required('Campo obligatorio'),
        telefonoCliDevuelve: Yup.string().required('Campo obligatorio')
    })


});

// convert dd/mm/yyyy to yyyy-mm-dd
const toIsoDate = value => {
    const parts = value.split('/');
    return parts[2] + '-' + parts[1] + '-' + parts[0];
};

const ActaDevolucion = ({ onCancel, contratoId, bastidor }) => {
    const [cookies] = useCookies([Globals.COOKIES.JWT]);
    const [dealersList, setDealersList] = useState([]);
    const [tiposIncidencia, setTiposIncidencia] = useState([]);
    const [selectedTipoIncidencia, setSelectedTipoIncidencia] = useState('');
    const [provincias, setProvincias] = useState([]);
    const [poblaciones, setPoblaciones] = useState([]);
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
    const fetchData = async () => {
            try {
                const token = cookies[Globals.COOKIES.JWT]?.AccessToken;
                const [dealersResponse, tiposIncidenciaResponse, provinciasResponse] = await Promise.all([
                    DealerService.getDealersList(token, cookies[Globals.COOKIES.USER]),
                    BackofficeService.getTiposIncidencia(token),
                    BackofficeService.getProvincias(token),
                ]); 
                setDealersList(dealersResponse?.body?.Result ?? []);
                setTiposIncidencia(tiposIncidenciaResponse ?? []);
                setSelectedTipoIncidencia(DEFAULT_TIPO_INCIDENCIA_ID);
                setProvincias(provinciasResponse ?? []);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
            window.bronson.ComponentRegister.initAll();
    }, []);

    const [actaDevolucionData, setActaDevolucionData] = useState({
        usuario: cookies[Globals.COOKIES.USER],
        polizaId: contratoId,
        bastidor: bastidor,
        fechaDevolucion: null,
        kmDevolucion: '',
        tipoIncidencia: 1,
        idCanal: '',
        devolucionCodTipoVia: '',
        devolucionNombreVia: '',
        devolucionPiso: '',
        devolucionNumeroVia: '',
        devolucionCodPostal: '',
        devolucionCodProvincia: '',
        devolucionCodPoblacion: '',
        observacionesUbicacion: '',
        personaRecogeVehiculo: '',
        emailContacto: '',
        telContacto: '',
        observaciones: '',
        perfilConcesionario: { 
            identificacionCliDevuelve:'',
            nombreCliDevuelve:'',
            primerApellidoCliDevuelve:'',
            segundoApellidoCliDevuelve: '',
            emailCliDevuelve:'',
            telefonoCliDevuelve:'',
            fichaTecnica:'X',
            permisoCirculacion:'X',
            libroInstrucciones:'X',
            libroMantenimiento:'X',
            varillaAntena:'X',
            segundoJuegoLlaves:'X',
            ruedaRepuesto:'X',
            compresor:'X',
            kitAntipinchazos:'X',
            gato:'X',
            navegador:'X',
            cableCarga:'X',
            vehiculoTransformado:'X',
            bolaRemolque:'X'
         },
    });
    // handler for fields (inputs and radios)
    const onChangeFields = e => {
        const { name, value } = e.target;
        // setActaDevolucionData(prev => ({ ...prev, [name]: value }));
        setActaDevolucionData(prev =>
            name in prev.perfilConcesionario
                ? { ...prev, perfilConcesionario: { ...prev.perfilConcesionario, [name]: value } }
                : { ...prev, [name]: value }
        );
    };

    const onChangeFechaDevolucion = fecha => {
        setActaDevolucionData(prev => ({ ...prev, fechaDevolucion: fecha }));
    };

    const onChangeProvincia = async e => {
        const codProvincia = e.target.value;
        // save the province and reset the dependent fields
        setActaDevolucionData(prev => ({ ...prev, devolucionCodProvincia: codProvincia, devolucionCodProvincia: '', devolucionCodPostal: '' }));
        if (!codProvincia) {
            setPoblaciones([]);
            return;
        }
        try {
            const response = await BackofficeService.getPoblaciones({ codProvincia }, cookies[Globals.COOKIES.JWT]?.AccessToken);
            setPoblaciones(response ?? []);
        } catch (error) {
            console.log(error);
        }
    };

    const onChangePoblacion = e => {
        const codPoblacion = e.target.value;
        const poblacion = poblaciones.find(p => String(p.codPoblacion) === codPoblacion);
        setActaDevolucionData(prev => ({ ...prev, devolucionCodProvincia: codPoblacion, devolucionCodPostal: poblacion?.codPostal ?? '' }));
    };

    const onSearchCodPostal = async e => {
        // Enter or blur: ignore any other key
        if (e.key && e.key !== 'Enter') return;
        const codPostal = e.target.value;

        if (!codPostal) {
            setActaDevolucionData(prev => ({ ...prev, devolucionCodProvincia: '', devolucionCodPoblacion: '' }));
            setPoblaciones([]);
            return;
        }

        try {
            const response = await BackofficeService.getPoblaciones({ codPostal }, cookies[Globals.COOKIES.JWT]?.AccessToken);
            const result = response ?? [];
            setPoblaciones(result);

            if (result.length > 0) {
                setActaDevolucionData(prev => ({ ...prev, devolucionCodProvincia: result[0].codProvincia, devolucionCodPoblacion: String(result[0].codPoblacion) }));
            }
        } catch (error) {
            console.log(error);
        }
    };
    // initialize dealer values
    const [dealerValues, setDealerValues] = useState({
        codTipoVia: '',
        nombreVia: '',
        numVia: '',
        piso: '',
        codPostal: '',
        nomProvincia: '',
        nomPoblacion: '',
    });

    const onChangeDealer = async idCanal => {
        try {
             setLoading(true);
            const token = cookies[Globals.COOKIES.JWT]?.AccessToken;
            const response = await BackofficeService.getCanales(
                idCanal,
                token);

            const dealerDetalle = response?.[0];
            const codProvincia = dealerDetalle?.codProvincia ?? '';

            if (codProvincia) {
                const poblacionesResponse = await BackofficeService.getPoblaciones({ codProvincia }, token);
                setPoblaciones(poblacionesResponse ?? []);
            }

            setActaDevolucionData(prev => ({
                ...prev,
                idCanal: idCanal,
                devolucionCodTipoVia: dealerDetalle?.codTipoVia ?? '',
                devolucionNombreVia: dealerDetalle?.nombreVia ?? '',
                devolucionNumeroVia: dealerDetalle?.numVia ?? '',
                devolucionPiso: dealerDetalle?.piso ?? '',
                devolucionCodProvincia: codProvincia,
                devolucionCodPostal: dealerDetalle?.codPostal ?? '',
                devolucionCodPoblacion: dealerDetalle?.codPoblacion != null ? String(dealerDetalle.codPoblacion) : '',
            }));
        } catch (error) {
            console.log(error);
        } finally {
             setLoading(false);
        }
    };

    const onSubmit = async () => {
        try {
            await actaDevolucionSchema.validate(actaDevolucionData, { abortEarly: false });
            setErrors({});
        } 
        catch (validationError) {
            // map each Yup error to its field path
            const newErrors = {};
            validationError.inner.forEach(err => { newErrors[err.path.split('.').pop()] = err.message; });
            setErrors(newErrors);

            // scroll to the topmost field with an error
            let topField = null;

            Object.keys(newErrors).forEach(key => {
                const field = document.querySelector('[name="' + key + '"]');
                if (field && (!topField || field.getBoundingClientRect().top < topField.getBoundingClientRect().top)) {
                    topField = field;
                }
            });

            if (topField) {
                topField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return;
        }
        const actaDevolucionRequest = { ...actaDevolucionData, fechaDevolucion: toIsoDate(actaDevolucionData.fechaDevolucion), kmDevolucion: Number(actaDevolucionData.kmDevolucion) };
        let response;
        setLoading(true);
        try
        {
            response = await BackofficeService.createActaDevolucion(actaDevolucionRequest, cookies[Globals.COOKIES.JWT]?.AccessToken);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setSubmitStatus(response !== undefined ? 'ok' : 'error');
    };

    if (submitStatus === 'ok') {
        return (
            <header class="c-section-heading  c-section-heading--center ">
                <h3 class="c-section-heading__title">
                    <span class="c-section-heading__title-text">El acta fue creada correctamente.</span>

                </h3>
            </header>
        );
    }
    if (submitStatus === 'error') {
        return (
            <header class="c-section-heading ">
                <button type="button" onClick={() => setSubmitStatus(null)} className="c-btn  c-btn--link  c-btn--small  c-btn--simple">
                        Volver al formulario
                    </button>
                <h3 class="c-section-heading__title">
                    <span class="c-section-heading__title-text">Ha ocurrido un error.</span>
                </h3>
                <p class="c-section-heading__subtitle">
                    No se pudo completar la operación. Intente nuevamente.
                </p>
            </header>
        );
    }

    return (
         <main id="main-content" class="o-main  ">
            {loading && <Loading  ariaBusy={true} />}
            <button type="button" onClick={onCancel} className="c-btn  c-btn--link  c-btn--small  c-btn--simple">
                    Volver
            </button>
            <section class="o-content-section  ">
                <div class="o-page-wrap  o-page-wrap--xsmall">
                    <form class="js-floating-label  " action="#0">
                        <fieldset class="o-fieldset">
                            <legend class="c-form-heading  ">
                                <span class="c-form-heading__title">
                                   <h1>Acta de Devolucion</h1>
                                </span>
                            </legend>
                        </fieldset>
                        {/* Datos de la devolución del Vehículo */}
                         <fieldset class="o-fieldset u-mt-large">
                            <legend class="c-form-heading  ">
                                <small class="c-form-heading__text">
                                    <h5>Datos de la devolución del Vehículo</h5>
                                </small>
                            </legend>
                            <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/3 u-1/1@xs">
                                        <div class="c-form-field ">
                                            <label for="fechaDevolucion">Fecha de devolución*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <DatePicker options={{ id: 'fecha-devolucion', type: 'default' }} onChange={onChangeFechaDevolucion} />
                                        </div>
                                        <p class="c-error-message" id="dummy-id-error-dont-use">
                                            {errors.fechaDevolucion && <span>{errors.fechaDevolucion}</span>}
                                        </p>
                                    </div>
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="kmDevolucion">Lectura km. devolución*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="kmDevolucion" class="c-input__input" id="kmDevolucion" type="text" 
                                                    value={actaDevolucionData.kmDevolucion} 
                                                    onChange={e => onChangeFields({ target: { name: 'kmDevolucion', value: e.target.value.replace(/\D/g, '') } })}/>
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.kmDevolucion && <span>{errors.kmDevolucion}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="tipoIncidencia">Incidencia (si aplica)</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div className="c-input c-input--select">
                                                <select
                                                    className="c-input__input"
                                                    onChange={onChangeFields}
                                                    value={actaDevolucionData.tipoIncidencia}
                                                >
                                                    <option value="" key={''}>
                                                        Seleccione Tipo Incidencia
                                                    </option>
                                                    {tiposIncidencia.map(
                                                        tipoIncidencia => (
                                                            <option
                                                                key={tipoIncidencia.idIncidencia}
                                                                value={tipoIncidencia.idIncidencia}
                                                            >
                                                            {tipoIncidencia.tipo}
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        {/* Datos de la ubicación  del Vehículo */}
                        <fieldset class="o-fieldset u-1/1 u-mt-large">
                            <legend class="c-form-heading  ">
                                <small class="c-form-heading__text">
                                    <h5>Datos de la ubicación  del Vehículo</h5>
                                </small>
                            </legend>
                            <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="concesionario">Concesionario*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div className="c-input c-input--select">
                                                <select name="concesionario"
                                                    className="c-input__input"
                                                    onChange={e => {
                                                        onChangeFields(e);
                                                        onChangeDealer(e.target.value);
                                                    }}
                                                    value={actaDevolucionData.dealer}>
                                                    <option value="" key={''}>
                                                        Seleccione un Concesionario
                                                    </option>
                                                    {dealersList.map(
                                                        dealer => (
                                                            <option
                                                                key={dealer.IdCanal}
                                                                value={dealer.IdCanal}
                                                            >
                                                            {dealer.NombreCanal}
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.concesionario && <span>{errors.concesionario}</span>}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="devolucionCodTipoVia">Tipo de vía*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="devolucionCodTipoVia" class="c-input__input" id="tipoVia" type="text"
                                                    value={actaDevolucionData.devolucionCodTipoVia}
                                                    onChange={onChangeFields} />
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.devolucionCodTipoVia && <span>{errors.devolucionCodTipoVia}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="devolucionNombreVia">Nombre de vía*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="devolucionNombreVia" class="c-input__input" id="devolucionNombreVia" type="text" 
                                                   value={actaDevolucionData.devolucionNombreVia}
                                                    onChange={onChangeFields} />
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.devolucionNombreVia && <span>{errors.devolucionNombreVia}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/3 u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="devolucionNumeroVia">Número*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="devolucionNumeroVia" class="c-input__input" id="devolucionNumeroVia" type="text" 
                                                    value={actaDevolucionData.devolucionNumeroVia}
                                                    onChange={onChangeFields} />
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.devolucionNumeroVia && <span>{errors.devolucionNumeroVia}</span>}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/4 u-1/1@xs">
                                        <div class="c-form-field ">
                                            <label for="devolucionPiso">Piso</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="devolucionPiso" class="c-input__input" id="devolucionPiso" type="text" 
                                                    value={actaDevolucionData.devolucionPiso}
                                                    onChange={onChangeFields} />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/4  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="devolucionCodPostal">Cosigo Postal*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="devolucionCodPostal" className="c-input__input" id="devolucionCodPostal" type="text" 
                                                        value={actaDevolucionData.devolucionCodPostal} onChange={e => setActaDevolucionData(prev => ({ ...prev, devolucionCodPostal: e.target.value }))} 
                                                        onKeyDown={onSearchCodPostal} onBlur={onSearchCodPostal} />
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.devolucionCodPostal && <span>{errors.devolucionCodPostal}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/4 u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="devolucionCodProvincia">Provincia*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div className="c-input c-input--select">
                                                <select name="devolucionCodProvincia" className="c-input__input" id="devolucionCodProvincia" value={actaDevolucionData.devolucionCodProvincia} onChange={onChangeProvincia}>
                                                    <option value="">Seleccione provincia</option>
                                                    {provincias.map(provincia => (
                                                        <option key={provincia.codProvincia} value={provincia.codProvincia}>{provincia.nombre}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                    {errors.devolucionCodProvincia && <span>{errors.devolucionCodProvincia}</span>}
                                            </p>
                                        </div>
                                    </div>
                                     <div class="o-layout__item  u-1/4 u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="devolucionCodPoblacion">Población*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div className="c-input c-input--select">
                                                <select name="devolucionCodPoblacion" className="c-input__input" id="devolucionCodPoblacion" value={actaDevolucionData.devolucionCodPoblacion} onChange={onChangePoblacion} disabled={!actaDevolucionData.devolucionCodProvincia}>
                                                    <option value="">Seleccione población</option>
                                                    {poblaciones.map(poblacion => (
                                                        <option key={poblacion.codPoblacion} value={poblacion.codPoblacion}>{poblacion.nombre}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.devolucionCodPoblacion && <span>{errors.devolucionCodPoblacion}</span>}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="o-fieldset__row">
                                <div class="c-form-field  c-form-field--textarea">
                                    <label for="observacionesUbicacion" class="c-form-field__label">
                                        Observaciones de la ubicación
                                    </label>
                                    <div class="c-form-field__box">
                                        <div class="c-input  c-input--textarea">
                                            <textarea name="observacionesUbicacion" id="observacionesUbicacion" class="c-input__input  "  value={actaDevolucionData.observacionesUbicacion} onChange={onChangeFields}></textarea>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        {/*  Datos del cliente que devuelve el vehículo */}
                        <fieldset class="o-fieldset u-mt-large">
                            <legend class="c-form-heading  ">
                                <small class="c-form-heading__text">
                                    <h5>Datos del cliente que devuelve el vehículo</h5>
                                </small>
                            </legend>
                            <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/4  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="identificacionCliDevuelve">NIF/NIE*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="identificacionCliDevuelve" class="c-input__input" id="identificacionCliDevuelve" type="text" 
                                                    value={actaDevolucionData.perfilConcesionario.identificacionCliDevuelve} onChange={onChangeFields}/>
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.identificacionCliDevuelve && <span>{errors.identificacionCliDevuelve}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/4  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="nombreCliDevuelve">Nombre*</label>
                                            <div class="c-form-field__box">
                                                <div class="c-input">
                                                    <input name="nombreCliDevuelve" class="c-input__input" id="nombreCliDevuelve" type="text" 
                                                        value={actaDevolucionData.perfilConcesionario.nombreCliDevuelve} onChange={onChangeFields}/>
                                                </div>
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.nombreCliDevuelve && <span>{errors.nombreCliDevuelve}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/4  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="primerApellidoCliDevuelve">Primer Apellido*</label>
                                            <div class="c-form-field__box">
                                                <div class="c-input">
                                                    <input name="primerApellidoCliDevuelve" class="c-input__input" id="primerApellidoCliDevuelve" type="text" 
                                                        value={actaDevolucionData.perfilConcesionario.primerApellidoCliDevuelve} onChange={onChangeFields} />
                                                </div>
                                                <p class="c-error-message" id="dummy-id-error-dont-use">
                                                    {errors.primerApellidoCliDevuelve && <span>{errors.primerApellidoCliDevuelve}</span>}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="o-layout__item  u-1/4  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="segundoApellidoCliDevuelve">Segundo Apellido*</label>
                                            <div class="c-form-field__box">
                                                <div class="c-input">
                                                    <input name="segundoApellidoCliDevuelve" class="c-input__input" id="segundoApellidoCliDevuelve" type="text" 
                                                        value={actaDevolucionData.perfilConcesionario.segundoApellidoCliDevuelve} onChange={onChangeFields}/>
                                                </div>
                                                <p class="c-error-message" id="dummy-id-error-dont-use">
                                                    {errors.segundoApellidoCliDevuelve && <span>{errors.segundoApellidoCliDevuelve}</span>}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/4 u-1/1@s">
                                            <div class="c-form-field ">
                                                <label for="emailCliDevuelve">Email*</label>
                                            </div>
                                            <div class="c-form-field__box">
                                                <div class="c-input">
                                                    <input name="emailCliDevuelve" class="c-input__input" id="emailCliDevuelve" type="text" 
                                                        value={actaDevolucionData.perfilConcesionario.emailCliDevuelve} onChange={onChangeFields}/>
                                                </div>
                                                <p class="c-error-message" id="dummy-id-error-dont-use">
                                                    {errors.emailCliDevuelve && <span>{errors.emailCliDevuelve}</span>}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="o-layout__item  u-1/4  u-1/1@s">
                                            <div class="c-form-field ">
                                                <label for="telefonoCliDevuelve">Teléfono*</label>
                                            </div>
                                            <div class="c-form-field__box">
                                                <div class="c-input">
                                                    <input name="telefonoCliDevuelve" class="c-input__input" id="telefonoCliDevuelve" type="text" 
                                                    value={actaDevolucionData.perfilConcesionario.telefonoCliDevuelve} onChange={onChangeFields} />
                                                </div>
                                                <p class="c-error-message" id="dummy-id-error-dont-use">
                                                    {errors.telefonoCliDevuelve && <span>{errors.telefonoCliDevuelve}</span>}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </fieldset>
                        {/*  Inspección del vehículo */}
                        <fieldset class="o-fieldset u-mt-large">
                            <legend class="c-form-heading  ">
                                <small class="c-form-heading__text">
                                    <h5>Inspección del vehículo</h5>
                                </small>
                            </legend>
                             {/*  Documentacion del vehículo */}
                             <div class="o-fieldset__row">
                                <legend class="c-form-heading  ">
                                    <small class="c-form-heading__text">
                                        <h6>Documentacion del vehiculo</h6>
                                    </small>
                                </legend>
                                <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/2  u-1/1@xs">
                                        <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                            <legend class="c-form-field__label">
                                                ¿Dispone de Ficha técnica?
                                            </legend>
                                            <div class="c-form-field__box">
                                                <div class="o-inline-group">
                                                    <div class="o-inline-group__item">
                                                        <label class="c-radio">
                                                            <input className="c-radio__input" type="radio" name="fichaTecnica" value="S" checked={actaDevolucionData.perfilConcesionario.fichaTecnica === 'S'} onChange={onChangeFields} />
                                                            <span class="c-radio__label">
                                                                Si
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div class="o-inline-group__item">
                                                        <label class="c-radio">
                                                            <input className="c-radio__input" type="radio" name="fichaTecnica" value="N" checked={actaDevolucionData.perfilConcesionario.fichaTecnica === 'N'} onChange={onChangeFields} />
                                                            <span class="c-radio__label">
                                                                No
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div class="o-inline-group__item">
                                                        <label class="c-radio">
                                                            <input className="c-radio__input" type="radio" name="fichaTecnica" value="X" checked={actaDevolucionData.perfilConcesionario.fichaTecnica === 'X'} onChange={onChangeFields} />
                                                            <span class="c-radio__label">
                                                                No Procede
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                    <div class="o-layout__item  u-1/2  u-1/1@xs">
                                        <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                            <legend class="c-form-field__label">
                                                ¿Dispone de Permiso de circulación?
                                            </legend>

                                            <div class="c-form-field__box">
                                                <div class="o-inline-group">
                                                    <div class="o-inline-group__item">
                                                        <label class="c-radio">
                                                            <input className="c-radio__input" type="radio" name="permisoCirculacion" value="S" checked={actaDevolucionData.perfilConcesionario.permisoCirculacion === 'S'} onChange={onChangeFields} />
                                                            <span class="c-radio__label">
                                                                Si
                                                            </span>
                                                        </label>

                                                    </div>
                                                    <div class="o-inline-group__item">
                                                        <label class="c-radio">
                                                            <input className="c-radio__input" type="radio" name="permisoCirculacion" value="N" checked={actaDevolucionData.perfilConcesionario.permisoCirculacion === 'N'} onChange={onChangeFields} />
                                                            <span class="c-radio__label">
                                                                No
                                                            </span>
                                                        </label>

                                                    </div>
                                                    <div class="o-inline-group__item">
                                                        <label class="c-radio">
                                                            <input className="c-radio__input" type="radio" name="permisoCirculacion" value="X" checked={actaDevolucionData.perfilConcesionario.permisoCirculacion === 'X'} onChange={onChangeFields} />
                                                            <span class="c-radio__label">
                                                                No Procede
                                                            </span>
                                                        </label>

                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Libro de instrucciones?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="libroInstrucciones" value="S" checked={actaDevolucionData.perfilConcesionario.libroInstrucciones === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="libroInstrucciones" value="N" checked={actaDevolucionData.perfilConcesionario.libroInstrucciones === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="libroInstrucciones" value="X" checked={actaDevolucionData.perfilConcesionario.libroInstrucciones === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Libro de mantenimiento?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="libroMantenimiento" value="S" checked={actaDevolucionData.perfilConcesionario.libroMantenimiento === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="libroMantenimiento" value="N" checked={actaDevolucionData.perfilConcesionario.libroMantenimiento === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="libroMantenimiento" value="X" checked={actaDevolucionData.perfilConcesionario.libroMantenimiento === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*  Faltantes del vehículo */}
                            <div class="o-fieldset__row">
                                <legend class="c-form-heading  ">
                                    <small class="c-form-heading__text">
                                        <h6>Faltantes del vehiculo</h6>
                                    </small>
                                </legend>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Varilla antena?
                                                </legend>
                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="varillaAntena" value="S" checked={actaDevolucionData.perfilConcesionario.varillaAntena === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="varillaAntena" value="N" checked={actaDevolucionData.perfilConcesionario.varillaAntena === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="varillaAntena" value="X" checked={actaDevolucionData.perfilConcesionario.varillaAntena === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Segundo juego de llaves?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="segundoJuegoLlaves" value="S" checked={actaDevolucionData.perfilConcesionario.segundoJuegoLlaves === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="segundoJuegoLlaves" value="N" checked={actaDevolucionData.perfilConcesionario.segundoJuegoLlaves === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="segundoJuegoLlaves" value="X" checked={actaDevolucionData.perfilConcesionario.segundoJuegoLlaves === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Rueda repuesto?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="ruedaRepuesto" value="S" checked={actaDevolucionData.perfilConcesionario.ruedaRepuesto === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="ruedaRepuesto" value="N" checked={actaDevolucionData.perfilConcesionario.ruedaRepuesto === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="ruedaRepuesto" value="X" checked={actaDevolucionData.perfilConcesionario.ruedaRepuesto === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Compresor?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="compresor" value="S" checked={actaDevolucionData.perfilConcesionario.compresor === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="compresor" value="N" checked={actaDevolucionData.perfilConcesionario.compresor === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="compresor" value="X" checked={actaDevolucionData.perfilConcesionario.compresor === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Kit antipinchazos?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="kitAntipinchazos" value="S" checked={actaDevolucionData.perfilConcesionario.kitAntipinchazos === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="kitAntipinchazos" value="N" checked={actaDevolucionData.perfilConcesionario.kitAntipinchazos === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="kitAntipinchazos" value="X" checked={actaDevolucionData.perfilConcesionario.kitAntipinchazos === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Gato?
                                                </legend>
                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="gato" value="S" checked={actaDevolucionData.perfilConcesionario.gato === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="gato" value="N" checked={actaDevolucionData.perfilConcesionario.gato === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="gato" value="X" checked={actaDevolucionData.perfilConcesionario.gato === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de CD/DVD/SD Navegador?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="navegador" value="S" checked={actaDevolucionData.perfilConcesionario.navegador === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="navegador" value="N" checked={actaDevolucionData.perfilConcesionario.navegador === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="navegador" value="X" checked={actaDevolucionData.perfilConcesionario.navegador === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Cable de carga?
                                                </legend>

                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="cableCarga" value="S" checked={actaDevolucionData.perfilConcesionario.cableCarga === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="cableCarga" value="N" checked={actaDevolucionData.perfilConcesionario.cableCarga === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="cableCarga" value="X" checked={actaDevolucionData.perfilConcesionario.cableCarga === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de  remolque homologada?
                                                </legend>
                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="bolaRemolque" value="S" checked={actaDevolucionData.perfilConcesionario.bolaRemolque === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="bolaRemolque" value="N" checked={actaDevolucionData.perfilConcesionario.bolaRemolque === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="bolaRemolque" value="X" checked={actaDevolucionData.perfilConcesionario.bolaRemolque === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-fieldset__row">
                                    <div class="o-layout">
                                        <div class="o-layout__item  u-1/2  u-1/1@xs">
                                            <fieldset class="c-form-field  c-form-field--static" role="radiogroup">
                                                <legend class="c-form-field__label">
                                                    ¿Dispone de Vehículo transformado?
                                                </legend>
                                                <div class="c-form-field__box">
                                                    <div class="o-inline-group">
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="vehiculoTransformado" value="S" checked={actaDevolucionData.perfilConcesionario.vehiculoTransformado === 'S'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    Si
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="vehiculoTransformado" value="N" checked={actaDevolucionData.perfilConcesionario.vehiculoTransformado === 'N'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No
                                                                </span>
                                                            </label>

                                                        </div>
                                                        <div class="o-inline-group__item">
                                                            <label class="c-radio">
                                                                <input className="c-radio__input" type="radio" name="vehiculoTransformado" value="X" checked={actaDevolucionData.perfilConcesionario.vehiculoTransformado === 'X'} onChange={onChangeFields} />
                                                                <span class="c-radio__label">
                                                                    No Procede
                                                                </span>
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        {/*  Responsable de retirada del vehículo */}
                        <fieldset class="o-fieldset u-mt-large">
                            <legend class="c-form-heading  ">
                                <small class="c-form-heading__text">
                                    <h5>Responsable de retirada del vehículo</h5>
                                </small>
                            </legend>
                            <div class="o-fieldset__row">
                                <div class="o-layout">
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="personaRecogeVehiculo">Persona que recoge el vehículo*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="personaRecogeVehiculo" class="c-input__input" id="personaRecogeVehiculo" type="text" value={actaDevolucionData.personaRecogeVehiculo} onChange={onChangeFields} />
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.personaRecogeVehiculo && <span>{errors.personaRecogeVehiculo}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/3  u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="emailContacto">Email*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="emailContacto" class="c-input__input" id="emailContacto" type="text" value={actaDevolucionData.emailRemailContactocoge} onChange={onChangeFields} />
                                            </div>
                                            <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.emailContacto && <span>{errors.emailContacto}</span>}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="o-layout__item  u-1/3 u-1/1@s">
                                        <div class="c-form-field ">
                                            <label for="telContacto">Telefono*</label>
                                        </div>
                                        <div class="c-form-field__box">
                                            <div class="c-input">
                                                <input name="telContacto" class="c-input__input" id="telContacto" type="text"  value={actaDevolucionData.telContacto} onChange={onChangeFields} />
                                            </div>
                                             <p class="c-error-message" id="dummy-id-error-dont-use">
                                                {errors.telContacto && <span>{errors.telContacto}</span>}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="o-fieldset__row">
                                <div class="c-form-field  c-form-field--textarea">
                                    <label for="observaciones" class="c-form-field__label">
                                        Observaciones
                                    </label>
                                    <div class="c-form-field__box">
                                        <div class="c-input  c-input--textarea">
                                            <textarea name="observaciones" id="observaciones" class="c-input__input  "  value={actaDevolucionData.observaciones} onChange={onChangeFields}></textarea>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <div class="o-fieldset">
                        <div class="o-fieldset__row">
                            <div class="o-button-container  o-button-container--nav">
                                <button className="c-btn o-button-container__button" type="button" onClick={onSubmit}>
                                    <span class="c-btn__text">
                                        Crear Acta
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    </form>
                </div>
            </section>
         </main>
    );
};

export default ActaDevolucion;